module.exports = __webpack_public_path__ + "img/bg08.083e069a.gif";